import React from 'react';
import './modal.css';

// Интерфейс для модального окна
export interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

// Компонент модального окна
const Modal = ({ title, onClose, children }: ModalProps) => {
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button onClick={onClose} className="modal-close-button">
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
